<template>
	<div v-loading="loading" class="base_scroll_page">
		<!-- 滚动区域 -->
		<div class="b_scroller">
			<!-- action -->
			<div style="font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="权限名称"
					>
					</el-table-column>
					<el-table-column
						prop="url"
						label="权限URL"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="200"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<!-- <div style="float: left;">
					<el-button type="danger" @click="handleDeleteClick">批量删除</el-button>
				</div> -->
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增 -->
		<Popup 
			v-model="add_display"
			title="新增权限"
			confirmBtnText="添加"
			@confirmClick="handleAddPopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>权限名称</span>
					<el-input v-model="add_name" placeholder="权限名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addName_tip"><i class="b_icon"></i>请输入权限名称</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>权限URL</span>
					<el-input v-model="add_url" placeholder="权限URL"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addUrl_tip"><i class="b_icon"></i>权限URL格式错误</template></div>
			</div>
		</Popup>
		<!-- 新增 end -->
		
		<!-- 修改 -->
		<Popup 
			v-model="update_display"
			title="修改权限"
			confirmBtnText="确定"
			@confirmClick="handleUpdatePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>权限名称</span>
					<el-input v-model="update_name" placeholder="权限名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateName_tip"><i class="b_icon"></i>请输入权限名称</template></div>
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>权限URL</span>
					<el-input v-model="update_url" placeholder="权限URL"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateUrl_tip"><i class="b_icon"></i>权限URL格式错误</template></div>
			</div>
		</Popup>
		<!-- 修改 end -->
	</div>
</template>

<script>
	import Api from '../../../../api/index.js';
	import { mapMutations } from 'vuex';
	
	export default{
		mounted() {
			this.getList();
		},
		data() {
			return{
				loading: false,
				tableData: [],
				currentPage: 1,
				total: 0,
				
				add_display: false,
				add_name: '',
				add_url: '',
				addName_tip: false,
				addUrl_tip: false,
				
				update_display: false,
				update_id: '',
				update_name: '',
				update_url: '',
				updateName_tip: false,
				updateUrl_tip: false
			}
		},
		methods: {
			/********************************* @Events *********************************/
			// 点击新增
			handleAddClick() {
				this.add_name = '';
				this.add_url = '';
				this.addName_tip = false;
				this.addUrl_tip = false;
				this.add_display = true;
			},
			// 页码改变
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			// 点击修改
			handleUpdateClick(obj) {
				this.update_id = obj.id;
				this.update_name = obj.name;
				this.update_url = obj.url;
				this.update_display = true;
			},
			// 点击删除
			handleDeleteClick(obj) {
				const that = this;
				that.$confirm(
					'此操作将删除该权限，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.delete(obj.id);
					}
				).catch(
					() => {}
				);
			},
			// 点击新增弹出框确定按钮
			handleAddPopupConfirmClick() {
				if (!this.add_name.trim()) {
					this.addName_tip = true;
					return false;
				} else {
					this.addName_tip = false;
				}
				if (!this.urlReg.test(this.add_url)) {
					this.addUrl_tip = true;
					return false;
				} else {
					this.addUrl_tip = false;
				}
				this.add();
			},
			// 点击修改弹出框确定按钮
			handleUpdatePopupConfirmClick() {
				if (!this.update_name.trim()) {
					this.updateName_tip = true;
					return false;
				} else {
					this.updateName_tip = false;
				}
				if (!this.urlReg.test(this.update_url)) {
					this.updateUrl_tip = true;
					return false;
				} else {
					this.updateUrl_tip = false;
				}
				this.update();
			},
			
			/********************************* @Events *********************************/
			// 获取数据
			getList() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10
				};
				Api.findPermissionByCondition(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.tableData = [];
						that.total = res.data.data.total;
						for (var i = 0;i < res.data.data.records.length;i++) {
							let o = res.data.data.records[i];
							that.tableData.push({
								id: o.privilegeId,
								name: o.privilegeName,
								url: o.privilegeUrl
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增权限
			add() {
				const that = this;
				that.loading = true;
				let requestData = {
					privilegeName: that.add_name,
					privilegeUrl: that.add_url
				};
				Api.addPermission(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.findPermission(res.data.message);
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 修改权限
			update() {
				const that = this;
				that.loading = true;
				let requestData = {
					privilegeId: that.update_id,
					privilegeName: that.update_name,
					privilegeUrl: that.update_url
				};
				Api.updatePermission(requestData).then((res) => {
					if (res.data.success) {
						that.findPermission(res.data.message);
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 删除权限
			delete(id) {
				const that = this;
				that.loading = true;
				Api.deletePermission(id).then((res) => {
					if (res.data.success) {
						that.findPermission(res.data.message || '删除成功！');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 获取权限列表
			findPermission(msg) {
				const that = this;
				Api.findPermission().then((res) => {
					that.loading = false;
					if (res.data.success) {
						let res_list = res.data.data || [];
						let list = [];
						res_list.forEach((v) => {
							list.push({
								id: v.privilegeId,
								name: v.privilegeName,
								url: v.privilegeUrl
							});
						});
						that.setAllPermission(list);
						that.add_display = false;
						that.update_display = false;
						that.$message.success(msg);
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			...mapMutations({
				'setAllPermission': 'setAllPermission'
			})
		}
	}
</script>

<style scoped>
</style>
